"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _inventory = require("@/api/inventory");
var _parsing = require("@/utils/parsing");
var _constants = require("@/views/inventory/constants");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Index',
  data: function data() {
    return {
      list: [],
      queryParams: {
        barcode: '',
        bizType: '',
        name: '',
        operator: '',
        limit: 20,
        page: 1
      },
      total: 0,
      bizTypeOptions: _constants.INVENTORY_BIZ_TYPE_ORDER.map(function (key) {
        return {
          value: key,
          label: _constants.INVENTORY_BIZ_TYPES[key]
        };
      }),
      bizTypeObj: _constants.INVENTORY_BIZ_TYPES
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var params = (0, _parsing.filterValidParams)(this.queryParams);
      (0, _inventory.inventoryTransactions)(params).then(function (response) {
        _this.total = response.total;
        _this.list = response.list;
      });
    },
    onQuery: function onQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    onReset: function onReset() {
      this.$refs.queryFormRef.resetFields();
      this.onQuery();
    },
    onPageChange: function onPageChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    onSizeChange: function onSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    }
  }
};